import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';

export interface PreformStatus {
  status: string;
}

export interface PreformDataResponse {
  data: PreformStatus[];
}

const fetchPreformData = async (): Promise<PreformDataResponse> => {
  const response = await axiosInstance().post<PreformDataResponse>('/communication/preForm');
  return response.data;
};

export const usePreformData = () => {
  const query = useQuery({
    queryKey: ['preformData'],
    queryFn: fetchPreformData,
    staleTime: 5 * 60 * 1000,
  });

  return {
    preformData: query.data?.data || [],
    isPreformLoading: query.isLoading,
    preformError: query.error,
  };
}; 